// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { useEnquiryModal } from "./EnquiryModal";
import { FaLocationDot } from "react-icons/fa6";
import { ENQUIRY_CTA } from "../constants";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="../Assets/banner1.webp"
            alt="Luxury View"
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            AZIZI FLORENCE
          </h2>
          <div className="luxury-location flex items-center">
            <FaLocationDot className="text-[#997736] mr-2" />
            <span className="text-[#997736] font-bold text-lg">Emirates Road, Sharjah</span>
          </div>
          <p>
            Azizi Florence is Sharjah’s largest master-planned residential community, sprawling over 30 million square feet along Sheikh Mohammed Bin Zayed Road. Developed by Azizi Developments, this freehold mega-project will feature 10,702 premium residences, including apartments, townhouses, and villas divided across six distinct architectural clusters. Designed for premium sustainable living, 25% of the development is dedicated to green landscapes, highlighted by a 1.7 million square foot Central Park. Residents enjoy access to over 85 lifestyle amenities, including a dedicated shopping mall, an international school, a hospital, and a boutique hotel. 
          </p>
          <button onClick={() => openModal(ENQUIRY_CTA.INTRO)} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>
    </div>
  );
};

export default LuxuryPage;
